import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import toast from 'react-hot-toast'

const CheckoutPage: React.FC = () => {
  const { user } = useAuth()
  const [selectedPlan, setSelectedPlan] = useState('pro')
  const [isProcessing, setIsProcessing] = useState(false)

  const plans = [
    {
      id: 'pro',
      name: 'Pro',
      price: 19,
      period: 'mese',
      features: [
        '50 crediti al mese',
        'Accesso completo alle funzionalità',
        'Supporto prioritario',
        'File upload illimitato'
      ]
    },
    {
      id: 'enterprise',
      name: 'Enterprise',
      price: 99,
      period: 'mese',
      features: [
        'Crediti illimitati',
        'Tutte le funzionalità Pro',
        'Supporto dedicato',
        'Integrazione personalizzata'
      ]
    }
  ]

  const handlePayment = async () => {
    setIsProcessing(true)
    
    // Simulate payment processing
    setTimeout(() => {
      toast.success('Pagamento completato con successo!')
      setIsProcessing(false)
    }, 2000)
  }

  const selectedPlanData = plans.find(plan => plan.id === selectedPlan)

  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900 mb-6">
            Completa il tuo Ordine
          </h3>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Plan Selection */}
            <div>
              <h4 className="text-md font-medium text-gray-900 mb-4">Seleziona Piano</h4>
              <div className="space-y-4">
                {plans.map((plan) => (
                  <div
                    key={plan.id}
                    className={`border rounded-lg p-4 cursor-pointer ${
                      selectedPlan === plan.id
                        ? 'border-primary-500 bg-primary-50'
                        : 'border-gray-300 hover:border-gray-400'
                    }`}
                    onClick={() => setSelectedPlan(plan.id)}
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <h5 className="font-medium text-gray-900">{plan.name}</h5>
                        <p className="text-sm text-gray-600">
                          €{plan.price}/{plan.period}
                        </p>
                      </div>
                      <input
                        type="radio"
                        name="plan"
                        value={plan.id}
                        checked={selectedPlan === plan.id}
                        onChange={() => setSelectedPlan(plan.id)}
                        className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300"
                      />
                    </div>
                    <ul className="mt-3 space-y-1">
                      {plan.features.map((feature, index) => (
                        <li key={index} className="text-sm text-gray-600 flex items-center">
                          <svg className="h-4 w-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            {/* Order Summary */}
            <div>
              <h4 className="text-md font-medium text-gray-900 mb-4">Riepilogo Ordine</h4>
              <div className="bg-gray-50 rounded-lg p-4">
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Piano selezionato:</span>
                    <span className="font-medium">{selectedPlanData?.name}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Prezzo:</span>
                    <span className="font-medium">€{selectedPlanData?.price}/{selectedPlanData?.period}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">IVA (22%):</span>
                    <span className="font-medium">€{((selectedPlanData?.price || 0) * 0.22).toFixed(2)}</span>
                  </div>
                  <hr className="border-gray-300" />
                  <div className="flex justify-between text-lg font-bold">
                    <span>Totale:</span>
                    <span>€{((selectedPlanData?.price || 0) * 1.22).toFixed(2)}</span>
                  </div>
                </div>

                <div className="mt-6">
                  <button
                    onClick={handlePayment}
                    disabled={isProcessing}
                    className="w-full bg-primary-600 text-white px-6 py-3 rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:opacity-50"
                  >
                    {isProcessing ? 'Elaborazione in corso...' : 'Completa Pagamento'}
                  </button>
                </div>

                <div className="mt-4 text-xs text-gray-500">
                  <p>• Il pagamento sarà processato in modo sicuro</p>
                  <p>• Puoi cancellare l'abbonamento in qualsiasi momento</p>
                  <p>• Rimborso entro 30 giorni se non soddisfatto</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CheckoutPage 